import {
  ActivityIndicator,
  FlatList,
  Image,
  Pressable,
  ScrollView,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
} from "react-native";
import { Modal, View } from "react-native";
import { AppColors } from "../../../../utility/AppColors";
import { AppFontStyle } from "../../../../styles/AppFontStyle";
import Ionicons from "@expo/vector-icons/Ionicons";
import { useEffect, useState } from "react";
import { AppImages } from "../../../../utility/AppImages";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { ShowLoader } from "../../../../common/ShowLoader";
import { base_url, endpoints } from "../../../../Api/configs";
import { toast } from "react-toastify";
import { searchUsers } from "../../../../services/eventsAPI";
import React from "react";
import { getLoginData } from "../../../../utility/AppStoreData";

export default function CompetitorsModal(props) {
  const {
    showModal = false,
    setShowModal,
    apiData,
    setApiData,
    accessToken,
    setRefreshAPICall,
    isUpdate = false,
    eventID = "",
  } = props;

  const [search, setSearch] = useState("");

  const [checked, setChecked] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [showCreateLoader, setCreateShowLoader] = useState(false);

  const [searchData, setSearchData] = useState([]);
  const [searchEmpty, setSearchEmpty] = useState(false);
  const [userData, setUserData] = useState(null);
  async function getLoginUserData() {
    const data = await getLoginData();

    if (data != null) {
      setUserData(data);
    }
  }
  const onCloseClick = () => {
    setShowModal(false);
  };

  useEffect(() => {}, [apiData]);

  const styles = useStyles();
  const deviceSize = useDeviceSize();

  const [participantIDs, setParticipantIDs] = useState<string[]>([]);

  function addParticipantIDs(element: string) {
    setParticipantIDs((prevIDs) => {
      if (!prevIDs.includes(element)) {
        return [...prevIDs, element];
      } else {
        return prevIDs;
      }
    });
  }

  function removeParticipantIDs(element: string) {
    setParticipantIDs((prevSearchData) =>
      prevSearchData.filter((item) => item !== element)
    );
  }

  function removeSearchDataElement(userID: string) {
    setSearchData((prevSearchData) =>
      prevSearchData.filter((item) => item.userID !== userID)
    );
  }

  type SearchDataType = {
    userID: string;
    profilePicture: string;
  };

  function deletePlayerFromSelelction(userID: string) {
    removeParticipantIDs(userID);
    addSearchData({ userID: userID, profilePicture: "" });
  }

  function addSearchData(element: SearchDataType) {
    setSearchData((prevData) => {
      const isAlreadyIncluded = prevData.some(
        (data) => data.userID === element.userID
      );

      if (!isAlreadyIncluded) {
        return [...prevData, element];
      } else {
        return prevData;
      }
    });
  }
  useEffect(() => {
    getLoginUserData();
  }, []);
  useEffect(() => {
    if (
      apiData &&
      apiData.participantIDs &&
      apiData.participantIDs.length > 0
    ) {
      if (isUpdate) {
        setParticipantIDs(apiData.participantIDs);
        if (apiData.captinIDs && apiData.captinIDs.length > 0) {
          setChecked(true);
        }
      }
    }
  }, [apiData]);

  const onChangeText = async (text: String) => {
    setSearch(text.toString());
    // if (text.length === 0) {
    //     toast.error("Please enter atleast 1 characters for search");
    //     return;
    // } else {
    if (text.length > 0) {
      const params = {
        query: text,
        currentUsername: userData?.username,
      };

      callSearchAPI({
        bodyParams: params,
        //@ts-ignore
        responceSuccess: (responce) => {
          if (responce) {
            if (Array.isArray(responce.results)) {
              if (responce.results.length === 0) {
                setSearchEmpty(true);
              } else {
                setSearchEmpty(false);
              }
              setSearchData(responce.results);
            } else {
              setSearchEmpty(true);
            }
          }
        },
      });
    } else {
      setSearchData([]);
    }
  };

  const callSearchAPI = async ({ bodyParams, responseSuccess }) => {
    setShowLoader(true);
    try {
      const data = await searchUsers(bodyParams);
      setShowLoader(false);

      if (data.statusCode === 200) {
        responseSuccess(data.body);
      } else {
        toast.error(data.body.error || "An error occurred");
      }
    } catch (error) {
      setShowLoader(false);
      toast.error(error.message);
    }
  };

  function checkValidation() {
    if (participantIDs.length < 2) {
      toast.error("Please select atleast 2 players");
    } else {
      const partData = apiData;
      delete partData.eventID;

      if (checked) {
        partData["participantIDs"] = participantIDs;
        partData["captinIDs"] = participantIDs;
        setApiData((prevData) => ({
          ...prevData,
          ["participantIDs"]: participantIDs,
        }));
        setApiData((prevData) => ({
          ...prevData,
          ["captinIDs"]: participantIDs,
        }));

        isUpdate ? callUpdateEventAPI(partData) : callCreateEventAPI(partData);
      } else {
        partData["participantIDs"] = participantIDs;
        setApiData((prevData) => ({
          ...prevData,
          ["participantIDs"]: participantIDs,
        }));
        isUpdate ? callUpdateEventAPI(partData) : callCreateEventAPI(partData);
      }

      // setTimeout(() => {
      // }, 2000);
      // setShowModal(false);
    }
  }

  function callCreateEventAPI(partData) {
    setCreateShowLoader(true);

    let url = base_url + endpoints.events.createEvent;

    const bodyParams = {
      accessToken: accessToken,
      eventDetails: partData,
    };

    return fetch(url, {
      mode: "cors",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        body: bodyParams,
      }),
    })
      .then(async function (data) {
        const responce = await data.json();
        const statusCode = data.status;

        setCreateShowLoader(false);

        if (statusCode === 200) {
          if (responce.statusCode === 200 || responce.statusCode === 201) {
            if (responce.body) {
              if (responce.body.message) {
                toast.success(responce.body.message);
                setShowModal(false);
                setRefreshAPICall(true);
              }
            }
          } else {
            toast.error(responce.body.error);
          }
        } else if (statusCode == 400) {
          toast.error("Bad Request");
        } else if (statusCode > 400 && statusCode < 420) {
          toast.error("Unauthorized");
        } else if (statusCode >= 500) {
          toast.error("Internal Server Error");
        }
      })
      .catch((error) => {
        setCreateShowLoader(false);
        toast.error(error.message);
      });
  }

  function callUpdateEventAPI(partData) {
    setCreateShowLoader(true);

    let url = base_url + endpoints.events.createEvent;

    const bodyParams = {
      accessToken: accessToken,
      eventID: eventID,
      newDetails: partData,
    };

    return fetch(url, {
      mode: "cors",
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        body: bodyParams,
      }),
    })
      .then(async function (data) {
        const responce = await data.json();
        const statusCode = data.status;

        setCreateShowLoader(false);

        if (statusCode === 200) {
          if (responce.statusCode === 200 || responce.statusCode === 201) {
            if (responce.body) {
              if (responce.body.message) {
                toast.success(responce.body.message);
                setRefreshAPICall(true);
                setShowModal(false);
              }
            }
          } else {
            toast.error(responce.body.error);
          }
        } else if (statusCode == 400) {
          toast.error("Bad Request");
        } else if (statusCode > 400 && statusCode < 420) {
          toast.error("Unauthorized");
        } else if (statusCode >= 500) {
          toast.error("Internal Server Error");
        }
      })
      .catch((error) => {
        setCreateShowLoader(false);
        toast.error(error.message);
      });
  }
  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={showModal}
      onRequestClose={onCloseClick}
    >
      <View style={styles.container}>
        <View style={styles.mainView}>
          <View style={{ flexDirection: "row", paddingTop: 20 }}>
            <Text style={[AppFontStyle.BOLD_ANYBODY_32, { flex: 1 }]}>
              Competitors
            </Text>
            <Ionicons
              name="close"
              size={35}
              color={AppColors.white}
              onPress={onCloseClick}
            />
          </View>
          <View
            style={{
              height: 2,
              marginTop: 16,
              backgroundColor: AppColors.appGrayColor_1C1C1C,
              width: "100%",
            }}
          />
          <ScrollView
            showsVerticalScrollIndicator={false}
            showsHorizontalScrollIndicator={false}
          >
            <View style={styles.searchWrapper}>
              <View
                style={{
                  flex: 1,
                  borderRadius: 15,
                  backgroundColor: AppColors.appGrayColor_1C1C1C,
                }}
              >
                <View
                  style={{
                    flexDirection: "row",
                    flex: 1,
                    borderRadius: 10,
                    backgroundColor: AppColors.gray_2a2a2a,
                    marginHorizontal: 16,
                    marginTop: 16,
                    marginBottom: 10,
                  }}
                >
                  <TextInput
                    placeholder={"Search for players"}
                    multiline={false}
                    placeholderTextColor={AppColors.gray_C3C3C3}
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_14,
                      styles.textInputStyle,
                    ]}
                    // ref={refValue}
                    onSubmitEditing={() => {}}
                    onChangeText={onChangeText}
                    keyboardType="default"
                    secureTextEntry={false}
                    value={search}
                  />
                  {showLoader ? (
                    <ActivityIndicator
                      style={{
                        alignSelf: "center",
                        paddingHorizontal: 10,
                      }}
                      size="small"
                      color={AppColors.themeColor_0A89AD}
                    />
                  ) : (
                    <Ionicons
                      name="search"
                      size={22}
                      style={{
                        alignSelf: "center",
                        paddingHorizontal: 10,
                      }}
                      color={AppColors.gray_C3C3C3}
                      onPress={() => {}}
                    />
                  )}
                </View>
                <View>
                  {
                    searchEmpty && (
                      <Text
                        style={[
                          AppFontStyle.REGULAR_ANYBODY_12,
                          {
                            color: AppColors.gray_C3C3C3,
                            marginHorizontal: 16,
                          },
                        ]}
                      >
                        No results found
                      </Text>
                    ) // : null
                  }
                  {
                    searchData.length > 0 && (
                      <Text
                        style={[
                          AppFontStyle.REGULAR_ANYBODY_16,
                          {
                            color: AppColors.gray_F5F5F5,
                            marginHorizontal: 16,
                            marginTop: 10,
                          },
                        ]}
                      >
                        {checked
                          ? "Select Captain for Squads"
                          : "Select Player 1 or player 2"}
                      </Text>
                    ) // : null
                  }
                  <View
                    style={{
                      flex: 1,
                      flexDirection: "row",
                      marginHorizontal: 12,
                      marginTop: 10,
                      flexWrap: "wrap",
                      gap: 10,
                    }}
                  >
                    {searchData.map((item, index) => {
                      return (
                        <View
                          key={index.toString()}
                          style={{
                            marginVertical: 5,
                          }}
                        >
                          <TouchableOpacity
                            style={{
                              borderRadius: 10,
                              backgroundColor: AppColors.gray_2a2a2a,
                              paddingHorizontal: 12,
                              paddingVertical: 8,
                            }}
                            activeOpacity={0.7}
                            onPress={() => {
                              addParticipantIDs(item.userID);
                              removeSearchDataElement(item.userID);
                            }}
                          >
                            <Text style={[AppFontStyle.MEDIUM_ANYBODY_12]}>
                              {item.userID}
                            </Text>
                          </TouchableOpacity>
                        </View>
                      );
                    })}
                  </View>
                </View>
                <View style={styles.inviteWrapper}>
                  <TouchableOpacity
                    style={{
                      borderRadius: 10,
                      backgroundColor: AppColors.gray_2a2a2a,

                      paddingHorizontal: 25,
                      paddingVertical: 12,
                    }}
                  >
                    <Text style={[AppFontStyle.BOLD_ANYBODY_12]}>
                      Invite a new player to ESQUADIFI
                    </Text>
                  </TouchableOpacity>
                  <TouchableOpacity
                    style={{
                      borderRadius: 10,
                      backgroundColor: AppColors.gray_2a2a2a,

                      paddingHorizontal: 25,
                      paddingVertical: 12,
                    }}
                  >
                    <Text style={[AppFontStyle.BOLD_ANYBODY_12]}>
                      Add yourself as a competitor
                    </Text>
                  </TouchableOpacity>
                </View>
              </View>
              <View
                style={{
                  marginEnd: 30,
                  marginStart: 5,
                }}
              >
                <TouchableOpacity
                  activeOpacity={0.7}
                  style={{
                    flexDirection: "row",
                    gap: 5,
                    marginTop: 10,
                  }}
                  onPress={() => setChecked(!checked)}
                >
                  <Image
                    style={{
                      width: 18,
                      height: 18,
                      resizeMode: "contain",
                    }}
                    source={
                      checked ? AppImages.icnChecked : AppImages.icnUnChecked
                    }
                  />
                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_14,
                      {
                        alignSelf: "center",
                        color: AppColors.gray_C3C3C3,
                      },
                    ]}
                  >
                    Team based
                  </Text>
                </TouchableOpacity>
              </View>
            </View>

            <Text
              style={[AppFontStyle.BOLD_ANYBODY_32, { flex: 1, marginTop: 35 }]}
            >
              {checked ? "Squads" : "Players"}
            </Text>

            <View
              style={{
                height: 2,
                marginTop: 10,
                backgroundColor: AppColors.appGrayColor_1C1C1C,
                width: "100%",
              }}
            />

            {/* App Players UI */}
            <View>
              <View style={styles.addPlayerStyle}>
                <View style={styles.playerStyle}>
                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_14,
                      styles.playerTextStyle,
                    ]}
                  >
                    {checked ? "Squad 1" : "Players 1"}
                  </Text>

                  {checked && (
                    <View style={styles.captainWrapper}>
                      <Text
                        style={[
                          AppFontStyle.REGULAR_ANYBODY_12,
                          styles.playerTextStyle,
                        ]}
                      >
                        Captain
                      </Text>
                      {participantIDs.length > 0 && (
                        <View
                          style={{
                            flex: 1,
                            justifyContent: "center",
                            alignItems: "center",
                            flexDirection: "row",
                            gap: 10,
                          }}
                        >
                          <Text
                            style={[
                              AppFontStyle.BOLD_ANYBODY_14,
                              {
                                alignSelf: "center",
                              },
                            ]}
                          >
                            {participantIDs.length > 0 ? participantIDs[0] : ""}
                          </Text>
                          <Ionicons
                            name="trash-outline"
                            size={18}
                            color={AppColors.red_FF2727}
                            onPress={() => {
                              deletePlayerFromSelelction(participantIDs[0]);
                            }}
                          />
                        </View>
                      )}
                    </View>
                  )}
                  {!checked && participantIDs.length > 0 && (
                    <View
                      style={{
                        flex: 1,
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "row",
                        gap: 10,
                      }}
                    >
                      <Text
                        style={[
                          AppFontStyle.BOLD_ANYBODY_14,
                          {
                            alignSelf: "center",
                          },
                        ]}
                      >
                        {participantIDs.length > 0 ? participantIDs[0] : ""}
                      </Text>
                      <Ionicons
                        name="trash-outline"
                        size={18}
                        color={AppColors.red_FF2727}
                        onPress={() => {
                          deletePlayerFromSelelction(participantIDs[0]);
                        }}
                      />
                    </View>
                  )}
                </View>
                <Image
                  source={AppImages.icVsLogo}
                  style={{
                    height: 58,
                    width: 58,
                    alignSelf: "center",
                    resizeMode: "contain",
                  }}
                />
                <View style={styles.playerStyle}>
                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_14,
                      styles.playerTextStyle,
                    ]}
                  >
                    {checked ? "Squad 2" : "Player 2"}
                  </Text>

                  {checked && (
                    <View style={styles.captainWrapper}>
                      <Text
                        style={[
                          AppFontStyle.REGULAR_ANYBODY_12,
                          styles.playerTextStyle,
                        ]}
                      >
                        Captain
                      </Text>
                      {participantIDs.length > 1 && (
                        <View
                          style={{
                            flex: 1,
                            justifyContent: "center",
                            alignItems: "center",
                            flexDirection: "row",
                            gap: 10,
                          }}
                        >
                          <Text
                            style={[
                              AppFontStyle.BOLD_ANYBODY_14,
                              {
                                alignSelf: "center",
                              },
                            ]}
                          >
                            {participantIDs.length > 1 ? participantIDs[1] : ""}
                          </Text>
                          <Ionicons
                            name="trash-outline"
                            size={18}
                            color={AppColors.red_FF2727}
                            onPress={() => {
                              deletePlayerFromSelelction(participantIDs[1]);
                            }}
                          />
                        </View>
                      )}
                    </View>
                  )}
                  {!checked && participantIDs.length > 1 && (
                    <View
                      style={{
                        flex: 1,
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "row",
                        gap: 10,
                      }}
                    >
                      <Text
                        style={[
                          AppFontStyle.BOLD_ANYBODY_14,
                          {
                            alignSelf: "center",
                          },
                        ]}
                      >
                        {participantIDs.length > 1 ? participantIDs[1] : ""}
                      </Text>
                      <Ionicons
                        name="trash-outline"
                        size={18}
                        color={AppColors.red_FF2727}
                        onPress={() => {
                          deletePlayerFromSelelction(participantIDs[1]);
                        }}
                      />
                    </View>
                  )}
                </View>
              </View>
            </View>

            <View
              style={{
                justifyContent: "flex-end",
                alignItems: "flex-end",
                marginHorizontal: 10,
              }}
            >
              <TouchableOpacity
                style={{
                  backgroundColor: AppColors.appViolentColor_6D08C3,
                  borderRadius: 10,
                  marginBottom: 30,
                }}
                onPress={() => {
                  checkValidation();
                }}
                activeOpacity={0.5}
              >
                <Text
                  style={[
                    AppFontStyle.BOLD_ANYBODY_12,
                    {
                      paddingVertical: 12,
                      paddingHorizontal: 18,
                      color: AppColors.white,
                    },
                  ]}
                >
                  Send
                </Text>
              </TouchableOpacity>
            </View>
          </ScrollView>
        </View>
        {<ShowLoader showIndicater={showCreateLoader} />}
      </View>
    </Modal>
  );
}

// const styles = StyleSheet.create(
const useStyles = CreateResponsiveStyle(
  {
    container: {
      flex: 1,
      backgroundColor: AppColors.blackTrans_000000a8,
    },
    mainView: {
      width: "50%",
      height: "90%",
      backgroundColor: AppColors.black_121212,
      paddingHorizontal: 20,
      margin: 30,
      alignSelf: "center",
      borderRadius: 12,
    },
    searchWrapper: {
      flexDirection: "row",
      gap: 10,
      marginTop: 20,
    },
    inviteWrapper: {
      flexDirection: "row",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      gap: 12,
      marginTop: 10,
      marginBottom: 16,
      marginHorizontal: 16,
    },
    textInputStyle: {
      paddingTop: 16,
      paddingBottom: 16,
      paddingHorizontal: 10,
      color: AppColors.white,
      flex: 1,
      outlineStyle: "none",
    },
    addPlayerStyle: {
      flexDirection: "row",
      marginHorizontal: 50,
      marginVertical: 20,
      gap: 20,
    },
    playerStyle: {
      flex: 1,
      height: 300,
      borderRadius: 10,
      backgroundColor: AppColors.appGrayColor_1C1C1C,
    },
    checkboxBase: {
      width: 18,
      height: 18,
      justifyContent: "center",
      alignItems: "center",
      borderRadius: 50,
      borderWidth: 2,
      borderColor: AppColors.gray_C3C3C3,
      backgroundColor: "transparent",
    },
    playerTextStyle: {
      color: AppColors.gray_C3C3C3,
      marginTop: 14,
      marginHorizontal: 10,
    },
    captainWrapper: {
      flex: 1,
      borderRadius: 10,
      backgroundColor: AppColors.gray_2a2a2a,
      margin: 10,
    },
  },
  {
    [DEVICE_SIZES.MD]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
      },
      mainView: {
        width: "80%",
        height: "90%",
        backgroundColor: AppColors.black_121212,
        paddingHorizontal: 20,
        margin: 30,
        alignSelf: "center",
        borderRadius: 12,
      },
      searchWrapper: {
        flexDirection: "row",
        gap: 10,
        marginTop: 20,
      },
      inviteWrapper: {
        flexDirection: "row",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        gap: 12,
        marginTop: 10,
        marginBottom: 16,
        marginHorizontal: 16,
      },
      textInputStyle: {
        paddingTop: 16,
        paddingBottom: 16,
        paddingHorizontal: 10,
        color: AppColors.white,
        flex: 1,
      },
      addPlayerStyle: {
        flexDirection: "row",
        marginHorizontal: 50,
        marginVertical: 20,
        gap: 20,
      },
      playerStyle: {
        flex: 1,
        height: 300,
        borderRadius: 10,
        backgroundColor: AppColors.appGrayColor_1C1C1C,
      },
      checkboxBase: {
        width: 18,
        height: 18,
        justifyContent: "center",
        alignItems: "center",
        borderRadius: 50,
        borderWidth: 2,
        borderColor: AppColors.gray_C3C3C3,
        backgroundColor: "transparent",
      },
      playerTextStyle: {
        color: AppColors.gray_C3C3C3,
        marginTop: 14,
        marginHorizontal: 10,
      },
      captainWrapper: {
        flex: 1,
        borderRadius: 10,
        backgroundColor: AppColors.gray_2a2a2a,
        margin: 10,
      },
    },
    [DEVICE_SIZES.LG]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
      },
      mainView: {
        width: "70%",
        height: "90%",
        backgroundColor: AppColors.black_121212,
        paddingHorizontal: 20,
        margin: 30,
        alignSelf: "center",
        borderRadius: 12,
      },
      searchWrapper: {
        flexDirection: "row",
        gap: 10,
        marginTop: 20,
      },
      inviteWrapper: {
        flexDirection: "row",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        gap: 12,
        marginTop: 10,
        marginBottom: 16,
        marginHorizontal: 16,
      },
      textInputStyle: {
        paddingTop: 16,
        paddingBottom: 16,
        paddingHorizontal: 10,
        color: AppColors.white,
        flex: 1,
      },
      addPlayerStyle: {
        flexDirection: "row",
        marginHorizontal: 50,
        marginVertical: 20,
        gap: 20,
      },
      playerStyle: {
        flex: 1,
        height: 300,
        borderRadius: 10,
        backgroundColor: AppColors.appGrayColor_1C1C1C,
      },
      checkboxBase: {
        width: 18,
        height: 18,
        justifyContent: "center",
        alignItems: "center",
        borderRadius: 50,
        borderWidth: 2,
        borderColor: AppColors.gray_C3C3C3,
        backgroundColor: "transparent",
      },
      playerTextStyle: {
        color: AppColors.gray_C3C3C3,
        marginTop: 14,
        marginHorizontal: 10,
      },
      captainWrapper: {
        flex: 1,
        borderRadius: 10,
        backgroundColor: AppColors.gray_2a2a2a,
        margin: 10,
      },
    },
    [DEVICE_SIZES.SM]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
      },
      mainView: {
        width: "95%",
        height: "90%",
        backgroundColor: AppColors.black_121212,
        paddingHorizontal: 20,
        margin: 30,
        alignSelf: "center",
        borderRadius: 12,
      },
      searchWrapper: {
        flexDirection: "column",
        gap: 10,
        marginTop: 20,
      },
      inviteWrapper: {
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        gap: 12,
        marginTop: 10,
        marginBottom: 16,
        marginHorizontal: 16,
      },
      textInputStyle: {
        paddingTop: 16,
        paddingBottom: 16,
        paddingHorizontal: 10,
        color: AppColors.white,
        flex: 1,
      },
      addPlayerStyle: {
        flexDirection: "column",
        height: 500,
        marginHorizontal: 20,
        marginVertical: 20,
        gap: 20,
      },
      playerStyle: {
        flex: 1,
        height: 300,
        borderRadius: 10,
        backgroundColor: AppColors.appGrayColor_1C1C1C,
      },
      checkboxBase: {
        width: 18,
        height: 18,
        justifyContent: "center",
        alignItems: "center",
        borderRadius: 50,
        borderWidth: 2,
        borderColor: AppColors.gray_C3C3C3,
        backgroundColor: "transparent",
      },
      playerTextStyle: {
        color: AppColors.gray_C3C3C3,
        marginTop: 14,
        marginHorizontal: 10,
      },
      captainWrapper: {
        flex: 1,
        borderRadius: 10,
        backgroundColor: AppColors.gray_2a2a2a,
        margin: 10,
      },
    },
    [DEVICE_SIZES.XS]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
      },
      mainView: {
        width: "95%",
        height: "90%",
        backgroundColor: AppColors.black_121212,
        paddingHorizontal: 20,
        margin: 30,
        alignSelf: "center",
        borderRadius: 12,
      },
      searchWrapper: {
        flexDirection: "column",
        gap: 10,
        marginTop: 20,
      },
      inviteWrapper: {
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        gap: 12,
        marginTop: 10,
        marginBottom: 16,
        marginHorizontal: 16,
      },
      textInputStyle: {
        paddingTop: 16,
        paddingBottom: 16,
        paddingHorizontal: 10,
        color: AppColors.white,
        flex: 1,
      },
      addPlayerStyle: {
        flexDirection: "column",
        height: 500,
        marginHorizontal: 20,
        marginVertical: 20,
        gap: 20,
      },
      playerStyle: {
        flex: 1,
        height: 300,
        borderRadius: 10,
        backgroundColor: AppColors.appGrayColor_1C1C1C,
      },
      checkboxBase: {
        width: 18,
        height: 18,
        justifyContent: "center",
        alignItems: "center",
        borderRadius: 50,
        borderWidth: 2,
        borderColor: AppColors.gray_C3C3C3,
        backgroundColor: "transparent",
      },
      playerTextStyle: {
        color: AppColors.gray_C3C3C3,
        marginTop: 14,
        marginHorizontal: 10,
      },
      captainWrapper: {
        flex: 1,
        borderRadius: 10,
        backgroundColor: AppColors.gray_2a2a2a,
        margin: 10,
      },
    },
  }
);
